import { call, select, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions';
import { ADD_CAR_UPLOAD_DOCUMENTS_REQUEST } from '../types';
import { addCarUploadDocumentsApi } from '../api';

export function* addCarUploadDocumentsRequestSaga(action) {
  try {
    const {
      payload: { document, reCaptchaToken, actionName, documentUrl },
    } = action;

    const {
      Data: { csrfToken },
    } = yield select();

    const formData = new FormData();
    formData.append('file', document);
    formData.append('token', reCaptchaToken);
    formData.append('actionName', actionName);

    const {
      data: { data: response },
    } = yield call(addCarUploadDocumentsApi, csrfToken, formData);

    if (!response) {
      throw new Error();
    }

    yield put(
      actions.addCarUploadDocumentsSuccess({
        fileType: response.fileType,
        name: actionName,
        uuid: response.uuid,
        documentUrl,
      })
    );
  } catch (e) {
    yield put(actions.addCarUploadDocumentsFailure());
  }
}

const addCarUploadDocumentsSaga = [
  takeLatest(ADD_CAR_UPLOAD_DOCUMENTS_REQUEST, addCarUploadDocumentsRequestSaga),
];

export default addCarUploadDocumentsSaga;
